import { useState } from 'react';
import { IconLogout, IconDotsVertical } from '@tabler/icons-react';
import { useAuth } from '@/contexts/AuthContext';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { useSidebar } from '@/components/ui/sidebar-context';

export default function Profile() {
  const { user, logout } = useAuth();
  const { isMobile } = useSidebar();
  const [avatarError, setAvatarError] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const avatarContent = (
    <Avatar className="size-8 rounded-lg">
      {user?.avatarUrl && !avatarError ? (
        <AvatarImage
          src={user.avatarUrl}
          alt={user?.name}
          referrerPolicy="no-referrer"
          onError={() => setAvatarError(true)}
        />
      ) : null}
      <AvatarFallback className="rounded-lg bg-primary text-primary-foreground text-sm font-semibold">
        {user?.name?.charAt(0)}
      </AvatarFallback>
    </Avatar>
  );

  return (
    <DropdownMenu>
      <SidebarMenuButton
        size="lg"
        className="data-open:bg-sidebar-accent data-open:text-sidebar-accent-foreground"
        render={<DropdownMenuTrigger />}
      >
        {avatarContent}
        <div className="grid flex-1 text-left text-sm leading-tight">
          <span className="truncate font-medium">{user?.name}</span>
          <span className="truncate text-xs text-foreground/70">
            {user?.email}
          </span>
        </div>
        <IconDotsVertical className="ml-auto size-4" />
      </SidebarMenuButton>
      <DropdownMenuContent
        className="w-(--anchor-width) min-w-56 rounded-lg"
        side={isMobile ? 'bottom' : 'top'}
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
              {avatarContent}
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{user?.name}</span>
                <span className="truncate text-xs text-muted-foreground">
                  {user?.email}
                </span>
              </div>
            </div>
          </DropdownMenuLabel>
        </DropdownMenuGroup>
        {user?.role && (
          <>
            <DropdownMenuSeparator />
            <div className="px-3 py-1.5">
              <span className="inline-block rounded px-2 py-0.5 text-xs font-medium bg-primary/10 text-primary">
                {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
              </span>
            </div>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="gap-2 cursor-pointer">
          <IconLogout size={18} />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
